import React, { useState, useEffect } from "react";
import {
  FaTv,
  FaPlay,
  FaMicrophone,
  FaCalendarAlt,
  FaExternalLinkAlt,
  FaVideo,
  FaGlobe,
  FaYoutube,
  FaPodcast,
} from "react-icons/fa";

const media = [
  {
    year: "2021–2025",
    title: "FITUR Madrid Presentations",
    type: "International Event",
    description:
      "Annual presentations at the world's leading tourism trade fair, showcasing Nepal's adventure tourism potential to global audiences.",
    icon: FaGlobe,
    color: "from-blue-500 to-cyan-500",
    image:
      "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?w=600&h=400&fit=crop",
    links: [
      { type: "Event", url: "#", label: "FITUR Official" },
      { type: "Gallery", url: "#", label: "Photo Gallery" },
    ],
  },
  {
    year: "2020–2024",
    title: "International TV Features",
    type: "Television",
    description:
      "Featured on Mexican TV, Bulgarian TV, and various Spanish-language programs discussing adventure tourism and cultural exchange.",
    icon: FaTv,
    color: "from-red-500 to-pink-500",
    image:
      "https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?w=600&h=400&fit=crop",
    links: [
      {
        type: "Video",
        url: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
        label: "Mexican TV Interview",
      },
      {
        type: "Video",
        url: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
        label: "Bulgarian Feature",
      },
      {
        type: "Video",
        url: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
        label: "Spanish Radio",
      },
    ],
  },
  {
    year: "2023",
    title: "Lions International Convention",
    type: "Convention Speaking",
    description:
      "Keynote presentation at Lions International Convention in Boston, USA, addressing global service and cultural understanding.",
    icon: FaMicrophone,
    color: "from-yellow-500 to-orange-500",
    image:
      "https://images.unsplash.com/photo-1475721027785-f74eccf877e2?w=600&h=400&fit=crop",
    links: [
      {
        type: "Video",
        url: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
        label: "Convention Speech",
      },
      { type: "Article", url: "#", label: "Event Coverage" },
    ],
  },
  {
    year: "2023",
    title: "BITT Dhaka",
    type: "Trade Show",
    description:
      "Participated in Bangladesh International Travel and Tourism Fair, promoting Nepal-Bangladesh tourism cooperation.",
    icon: FaGlobe,
    color: "from-green-500 to-teal-500",
    image:
      "https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=600&h=400&fit=crop",
    links: [
      { type: "Gallery", url: "#", label: "Event Photos" },
      { type: "Article", url: "#", label: "Press Coverage" },
    ],
  },
  {
    year: "2015, 2019",
    title: "Go Dharmic Events",
    type: "Cultural Event",
    description:
      "Organized and spoke at Go Dharmic cultural events in Ahmedabad, India, focusing on spiritual tourism and cultural preservation.",
    icon: FaMicrophone,
    color: "from-purple-500 to-violet-500",
    image:
      "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=600&h=400&fit=crop",
    links: [
      {
        type: "Video",
        url: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
        label: "Event Highlights",
      },
      { type: "Gallery", url: "#", label: "Photo Gallery" },
    ],
  },
];

const podcasts = [
  {
    title: "Adventure Tourism Insights",
    description:
      "Deep dive into the world of Himalayan adventure tourism, sharing experiences from 15+ years in the industry.",
    platform: "Spotify",
    duration: "45 min",
    image:
      "https://images.unsplash.com/photo-1478737270239-2f02b77fc618?w=300&h=300&fit=crop",
    url: "https://open.spotify.com/show/example",
    topics: [
      "Adventure Tourism",
      "Nepal",
      "Cultural Exchange",
      "Business Leadership",
    ],
  },
  {
    title: "Cultural Bridges Podcast",
    description:
      "Discussing how travel creates connections between cultures and the importance of sustainable tourism practices.",
    platform: "Apple Podcasts",
    duration: "38 min",
    image:
      "https://images.unsplash.com/photo-1590602847861-f357a9332bbc?w=300&h=300&fit=crop",
    url: "https://podcasts.apple.com/podcast/example",
    topics: [
      "Cultural Exchange",
      "Sustainability",
      "Global Connections",
      "Travel Philosophy",
    ],
  },
  {
    title: "Entrepreneurship in Tourism",
    description:
      "From teacher to tourism entrepreneur: lessons learned building successful businesses in the adventure travel industry.",
    platform: "YouTube",
    duration: "52 min",
    image:
      "https://images.unsplash.com/photo-1611348586804-61bf6c080437?w=300&h=300&fit=crop",
    url: "https://www.youtube.com/watch?v=example",
    topics: [
      "Entrepreneurship",
      "Business Growth",
      "Leadership",
      "Tourism Industry",
    ],
  },
];

const videos = [
  {
    title: "Nepal Adventure Tourism Documentary",
    description:
      "A comprehensive look at Nepal's adventure tourism industry and sustainable practices.",
    thumbnail:
      "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600&h=400&fit=crop",
    duration: "12:30",
    views: "25K",
    url: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
  },
  {
    title: "Cultural Heritage Tours",
    description:
      "Exploring Nepal's rich cultural heritage through immersive travel experiences.",
    thumbnail:
      "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=600&h=400&fit=crop",
    duration: "8:45",
    views: "18K",
    url: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
  },
  {
    title: "Everest Base Camp Journey",
    description:
      "Behind the scenes of organizing and leading Everest Base Camp expeditions.",
    thumbnail:
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=600&h=400&fit=crop",
    duration: "15:20",
    views: "42K",
    url: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
  },
  {
    title: "Sustainable Tourism Practices",
    description:
      "How we implement eco-friendly and community-supporting tourism practices.",
    thumbnail:
      "https://images.unsplash.com/photo-1544735716-392fe2489ffa?w=600&h=400&fit=crop",
    duration: "10:15",
    views: "12K",
    url: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
  },
];

export default function Media() {
  // const [selectedMedia, setSelectedMedia] = useState(null);
  const [activeTab, setActiveTab] = useState("appearances");
  const [visibleItems, setVisibleItems] = useState([]);
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", handleScroll);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisibleItems((prev) => [...prev, entry.target.dataset.index]);
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll(".media-item").forEach((item, index) => {
      item.dataset.index = index;
      observer.observe(item);
    });

    return () => {
      window.removeEventListener("scroll", handleScroll);
      observer.disconnect();
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-rose-900 to-slate-900">
      {/* Hero Section */}
      <div className="relative pt-24 pb-16 px-6 lg:px-20">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h1 className="text-6xl md:text-8xl font-black mb-6 bg-gradient-to-r from-rose-400 via-pink-400 to-red-400 bg-clip-text text-transparent">
              Media & Recognition
            </h1>
            <div className="w-32 h-1 bg-gradient-to-r from-rose-500 to-pink-500 mx-auto mb-8 rounded-full"></div>
            <p className="text-xl md:text-2xl text-gray-300 max-w-4xl mx-auto leading-relaxed">
              Sharing stories and insights through international media
              platforms, promoting Nepal's rich culture and adventure tourism to
              global audiences.
            </p>
          </div>

          {/* Tab Navigation */}
          <div className="flex flex-wrap justify-center gap-4 mb-16">
            {[
              { id: "appearances", label: "Media Appearances", icon: FaTv },
              { id: "podcasts", label: "Podcasts", icon: FaPodcast },
              { id: "videos", label: "Video Content", icon: FaVideo },
            ].map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center space-x-2 px-6 py-3 rounded-full font-semibold transition-all duration-300 ${
                  activeTab === tab.id
                    ? "bg-gradient-to-r from-rose-600 to-pink-600 text-white shadow-2xl shadow-rose-500/25"
                    : "bg-white/10 text-gray-300 hover:bg-white/20"
                }`}
              >
                <tab.icon className="w-5 h-5" />
                <span>{tab.label}</span>
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Media Appearances */}
      {activeTab === "appearances" && (
        <div className="px-6 lg:px-20 py-16">
          <div className="max-w-6xl mx-auto">
            <div className="space-y-12">
              {media.map((item, index) => (
                <div
                  key={index}
                  className={`media-item transition-all duration-1000 ${
                    visibleItems.includes(index.toString())
                      ? "opacity-100 translate-y-0"
                      : "opacity-0 translate-y-12"
                  }`}
                >
                  <div className="bg-white/5 backdrop-blur-xl rounded-3xl overflow-hidden border border-white/10 hover:border-rose-500/50 transition-all duration-500 group">
                    <div
                      className={`grid lg:grid-cols-5 gap-0 ${
                        index % 2 === 0 ? "" : "lg:grid-flow-col-dense"
                      }`}
                    >
                      {/* Image Section */}
                      <div
                        className={`lg:col-span-2 relative overflow-hidden ${
                          index % 2 === 0 ? "" : "lg:order-last"
                        }`}
                      >
                        <div className="aspect-video lg:aspect-square">
                          <img
                            src={item.image}
                            alt={item.title}
                            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>

                          {/* Icon Overlay */}
                          <div
                            className={`absolute bottom-4 right-4 w-16 h-16 bg-gradient-to-r ${item.color} rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}
                          >
                            <item.icon className="w-8 h-8 text-white" />
                          </div>
                        </div>
                      </div>

                      {/* Content Section */}
                      <div className="lg:col-span-3 p-8 lg:p-12 flex flex-col justify-center">
                        <div className="space-y-6">
                          <div>
                            <div className="flex items-center justify-between mb-3">
                              <span className="px-3 py-1 bg-rose-500/20 text-rose-300 rounded-full text-sm font-medium">
                                {item.type}
                              </span>
                              <div className="flex items-center space-x-2 text-gray-400">
                                <FaCalendarAlt className="w-4 h-4" />
                                <span className="text-sm font-medium">
                                  {item.year}
                                </span>
                              </div>
                            </div>
                            <h3 className="text-2xl md:text-3xl font-bold text-white group-hover:text-rose-300 transition-colors duration-300 mb-3">
                              {item.title}
                            </h3>
                            <p className="text-gray-300 leading-relaxed">
                              {item.description}
                            </p>
                          </div>

                          {/* Links */}
                          <div className="flex flex-wrap gap-3">
                            {item.links.map((link, linkIndex) => (
                              <a
                                key={linkIndex}
                                href={link.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center space-x-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-sm font-medium text-white hover:bg-rose-500/20 transition-all duration-300 hover:scale-105"
                              >
                                <FaExternalLinkAlt className="w-3 h-3" />
                                <span>{link.label}</span>
                              </a>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Podcasts Section */}
      {activeTab === "podcasts" && (
        <div className="px-6 lg:px-20 py-16">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-white mb-4">
                Podcast Appearances
              </h2>
              <p className="text-xl text-gray-300">
                Sharing insights and experiences through audio storytelling
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {podcasts.map((podcast, index) => (
                <div
                  key={index}
                  className="bg-white/5 backdrop-blur-xl rounded-3xl p-6 border border-white/10 hover:border-rose-500/50 transition-all duration-500 hover:scale-105 group"
                >
                  <div className="space-y-6">
                    {/* Podcast Cover */}
                    <div className="relative">
                      <img
                        src={podcast.image}
                        alt={podcast.title}
                        className="w-full aspect-square rounded-2xl object-cover group-hover:scale-105 transition-transform duration-300"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent rounded-2xl"></div>

                      {/* Play Button */}
                      <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <div className="w-16 h-16 bg-rose-500/80 backdrop-blur-sm rounded-full flex items-center justify-center">
                          <FaPlay className="w-6 h-6 text-white ml-1" />
                        </div>
                      </div>

                      {/* Duration Badge */}
                      <div className="absolute top-4 right-4 bg-black/60 backdrop-blur-sm rounded-full px-3 py-1 text-sm font-medium text-white">
                        {podcast.duration}
                      </div>
                    </div>

                    {/* Content */}
                    <div className="space-y-4">
                      <div>
                        <h3 className="text-xl font-bold text-white group-hover:text-rose-300 transition-colors duration-300 mb-2">
                          {podcast.title}
                        </h3>
                        <p className="text-gray-300 text-sm leading-relaxed">
                          {podcast.description}
                        </p>
                      </div>

                      {/* Platform */}
                      <div className="flex items-center justify-between">
                        <span className="px-3 py-1 bg-rose-500/20 text-rose-300 rounded-full text-sm font-medium">
                          {podcast.platform}
                        </span>
                        <a
                          href={podcast.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex items-center space-x-2 text-rose-400 hover:text-rose-300 transition-colors"
                        >
                          <span className="text-sm font-medium">Listen</span>
                          <FaExternalLinkAlt className="w-3 h-3" />
                        </a>
                      </div>

                      {/* Topics */}
                      <div className="flex flex-wrap gap-2">
                        {podcast.topics.map((topic, topicIndex) => (
                          <span
                            key={topicIndex}
                            className="px-2 py-1 bg-white/10 rounded-full text-xs text-gray-300"
                          >
                            {topic}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Videos Section */}
      {activeTab === "videos" && (
        <div className="px-6 lg:px-20 py-16">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-white mb-4">
                Video Content
              </h2>
              <p className="text-xl text-gray-300">
                Visual storytelling of adventures and experiences
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-8">
              {videos.map((video, index) => (
                <div
                  key={index}
                  className="bg-white/5 backdrop-blur-xl rounded-3xl overflow-hidden border border-white/10 hover:border-rose-500/50 transition-all duration-500 hover:scale-[1.02] group cursor-pointer"
                  onClick={() => window.open(video.url, "_blank")}
                >
                  <div className="relative">
                    <img
                      src={video.thumbnail}
                      alt={video.title}
                      className="w-full aspect-video object-cover group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>

                    {/* Play Button */}
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="w-20 h-20 bg-red-600/80 backdrop-blur-sm rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                        <FaYoutube className="w-10 h-10 text-white" />
                      </div>
                    </div>

                    {/* Duration */}
                    <div className="absolute bottom-4 right-4 bg-black/80 backdrop-blur-sm rounded px-2 py-1 text-sm font-medium text-white">
                      {video.duration}
                    </div>

                    {/* Views */}
                    <div className="absolute bottom-4 left-4 bg-black/80 backdrop-blur-sm rounded px-2 py-1 text-sm font-medium text-white">
                      {video.views} views
                    </div>
                  </div>

                  <div className="p-6">
                    <h3 className="text-xl font-bold text-white group-hover:text-rose-300 transition-colors duration-300 mb-3">
                      {video.title}
                    </h3>
                    <p className="text-gray-300 leading-relaxed">
                      {video.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Call to Action */}
      <div className="px-6 lg:px-20 py-16">
        <div className="max-w-4xl mx-auto text-center">
          <div className="bg-white/5 backdrop-blur-xl rounded-3xl p-12 border border-white/10">
            <FaMicrophone className="w-16 h-16 text-rose-400 mx-auto mb-6" />
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Media Collaborations Welcome
            </h3>
            <p className="text-xl text-gray-300 mb-8 leading-relaxed">
              Interested in featuring Nepal's adventure tourism story? Let's
              create compelling content together that showcases the beauty and
              culture of the Himalayas.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="px-8 py-4 bg-gradient-to-r from-rose-600 to-pink-600 rounded-full font-semibold text-white hover:from-pink-600 hover:to-rose-600 transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-rose-500/25">
                <span className="flex items-center space-x-2">
                  <FaMicrophone className="w-5 h-5" />
                  <span>Book Interview</span>
                </span>
              </button>
              <button className="px-8 py-4 border-2 border-white/20 rounded-full font-semibold text-white hover:bg-white/10 transition-all duration-300">
                <span className="flex items-center space-x-2">
                  <FaVideo className="w-5 h-5" />
                  <span>Request Media Kit</span>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Background Elements */}
      <div className="fixed inset-0 pointer-events-none opacity-5">
        <div
          className="absolute w-96 h-96 bg-gradient-to-r from-rose-500/30 to-pink-500/30 rounded-full blur-3xl"
          style={{
            transform: `translate(${scrollY * 0.1}px, ${scrollY * 0.05}px)`,
            left: "10%",
            top: "20%",
          }}
        ></div>
        <div
          className="absolute w-96 h-96 bg-gradient-to-r from-pink-500/30 to-red-500/30 rounded-full blur-3xl"
          style={{
            transform: `translate(-${scrollY * 0.1}px, -${scrollY * 0.05}px)`,
            right: "10%",
            bottom: "20%",
          }}
        ></div>
      </div>
    </div>
  );
}
